<template>
  <Card :footerDivider="false" :loadingState="loading" :title="$t('change.title')">
    <template v-slot:content>
      <div class="container manufacturer">
        <div class="h4 title">{{ $t('change.search.basicTitle') }}</div>
        <div class="card-row">
          <div class="card-row__col">
            <BasicTextfield
              :label="$t('change.search.manufacturerId')"
              :status="manufacturerIdStatus"
              @focus="manufacturerIdStatus = InputStatus.DEFAULT"
              @input="(val) => validateManufacturerId(true, val)"
              id="manufacturerId"
              inputmode="numeric"
              :value="manufacturerId"
            >
              <template v-slot:info>{{
                $t('change.search.infoMessages.manufacturerId')
              }}</template>
              <template v-slot:error
                >{{ $t('change.search.validationMessages.manufacturerId') }}
              </template>
            </BasicTextfield>
          </div>
          <div class="card-row__col">
            <BasicTextfield
              :label="$t('change.search.typeKey')"
              :status="typeKeyStatus"
              @focus="typeKeyStatus = InputStatus.DEFAULT"
              @input="(val) => validateTypeKeyId(true, val)"
              id="typeKey"
              :value="typeKey"
            >
              <template v-slot:info>{{
                $t('change.search.infoMessages.typeKey')
              }}</template>
              <template v-slot:error
                >{{ $t('change.search.validationMessages.typeKey') }}
              </template>
            </BasicTextfield>
          </div>
        </div>
        <div v-if="!vehicleSearchResultText" class="card-row">
          <a @click.prevent="openHelpHsnTsn" class="help-link" href="" tabindex="0">
            {{ $t('change.search.hsnTsnHelpTitle') }}<span class="icon-vorteile"></span
          ></a>
        </div>
      </div>

      <div class="container vehicleresult">
        <div class="card-row search-result" v-if="vehicleSearchResultText">
          <div class="card-row__col">
            <div v-if="vehicleSearchResult">
              <div class="h4 title">{{ $t('change.search.myNewCar') }}</div>
            </div>
            <div class="search-result-text" id="search-result-text">
              <p v-html="vehicleSearchResultText"></p>
            </div>
          </div>
        </div>
      </div>

      <div class="container inputs">
        <div class="card-row">
          <!-- first registration  -->
          <div class="card-row__col">
            <DateInput
              :label="$t('change.search.firstRegistration')"
              :mask="dateFormatPattern"
              :placeholder="dateInputMask"
              :status="firstRegistrationStatus"
              @blur="validateFirstRegistration"
              id="firstRegistration"
              type="text"
              v-model="firstRegistration"
            >
              <template v-slot:error>{{ firstRegistrationError }} </template>
            </DateInput>
          </div>
          <div class="card-row__col">
            <DateInput
              :label="$t('change.search.firstRegistrationOnMe')"
              :mask="dateFormatPattern"
              :placeholder="dateInputMask"
              :status="firstRegistrationOnMeStatus"
              @blur="validateFirstRegistrationOnMe"
              id="firstRegistrationOnMe"
              type="text"
              v-model="firstRegistrationOnMe"
            >
              <template v-slot:error>{{ firstRegistrationOnMeError }} </template>
            </DateInput>
          </div>
        </div>
        <div class="card-row reverse-row-mobile">
          <!-- first registration on me-->
          <div class="card-row__col reg-link">
            <a
              @click.prevent="openHelpRegistration"
              class="help-link mb-16"
              href=""
              tabindex="0"
              >{{ $t('change.search.registrationHelpTitle')
              }}<span class="icon-vorteile"></span
            ></a>
          </div>
          <div class="card-row__col reg-checkbox">
            <Checkbox
              style="margin-top: -6px"
              :label="$t('change.search.sameAsFirstRegistration')"
              @change="sameAsFirstRegClicked"
              idProp="sameAsfirstRegistration"
              v-model="sameAsFirstRegistrationOnMe"
            >
            </Checkbox>
          </div>
        </div>

        <div class="card-row separator"></div>

        <div class="card-row">
          <!-- mileage-->
          <div class="card-row__col">
            <BasicTextfield
              id="mileage"
              :label="$t('change.search.mileage')"
              inputmode="numeric"
              :value="mileage"
              @input="(val) => validateMileage(true, val)"
              @focus="mileageStatus = InputStatus.DEFAULT"
              :status="mileageStatus"
            >
              <template v-slot:info>{{
                $t('change.search.infoMessages.mileage')
              }}</template>
              <template v-slot:error>{{ mileageError }}</template>
            </BasicTextfield>
          </div>
          <!-- insurance begin  -->
          <div class="card-row__col">
            <DateInput
              :label="$t('change.search.insuranceBegin')"
              :mask="dateFormatPattern"
              :placeholder="dateInputMask"
              :status="insuranceBeginStatus"
              @blur="validateInsuranceBegin"
              @focus="insuranceBeginStatus = InputStatus.DEFAULT"
              @input="validateInsuranceBegin"
              id="insuranceBegin"
              v-model="insuranceBegin"
            >
              <template #info>{{
                $t('change.search.infoMessages.insuranceBegin')
              }}</template>
              <template #error>{{ insuranceBeginError }}</template>
            </DateInput>
          </div>
        </div>
      </div>

      <div class="container inputs2"></div>

      <div class="container usergroup mb-16">
        <!--Nutzerkreis-->
        <div class="h4 title">{{ $t('change.search.userGroup.whoDrivesMyCar') }}</div>
        <div class="card-row">
          <div class="card-row__col">
            <Checkbox
              :label="$t('change.search.userGroup.policyHolder')"
              :status="disabledStatus"
            >
            </Checkbox>
          </div>
        </div>
        <div class="card-row">
          <div class="card-row__col">
            <Checkbox
              :label="$t('change.search.userGroup.partner')"
              @input="userGroupPartnerClicked"
              idProp="userGroupPartner"
              v-model="userGroupPartner"
            >
            </Checkbox>
          </div>
        </div>
        <div class="card-row" v-if="userGroupPartner">
          <div class="card-row__col">
            <BasicTextfield
              class="mt-16"
              :label="$t('change.search.userGroup.birthyearPartner')"
              :placeholder="yearInputMask"
              :status="birthyearPartnerStatus"
              @blur="(val: string) => validateBirthyearPartner(val)"
              @input="(val: string) => validateBirthyearPartner(val)"
              id="birthyearPartner"
              inputmode="numeric"
              :value="birthyearPartner"
            >
              <template v-slot:error>{{ birthyearPartnerError }} </template>
            </BasicTextfield>
          </div>
          <div class="card-row__col">
            <!--Intentionally left blank to control size of single input field for partner birthyear-->
          </div>
        </div>
        <div class="card-row">
          <div class="card-row__col">
            <Checkbox
              :label="$t('change.search.userGroup.others')"
              @input="userGroupOthersClicked"
              idProp="userGroupOthers"
              v-model="userGroupOthers"
            >
            </Checkbox>
          </div>
        </div>
        <div class="card-row mt-16" v-if="userGroupOthers">
          <div class="card-row__col">
            <BasicTextfield
              :label="$t('change.search.userGroup.birthyearOldest')"
              :placeholder="yearInputMask"
              :status="birthyearOldestStatus"
              @blur="(val: string) => validateBirthyearOldest(val)"
              @input="(val: string) => validateBirthyearOldest(val)"
              id="birthyearOldest"
              inputmode="numeric"
              :value="birthyearOldest"
            >
              <template v-slot:error>{{ birthyearOldestError }} </template>
            </BasicTextfield>
          </div>
          <div class="card-row__col">
            <BasicTextfield
              :label="$t('change.search.userGroup.birthyearYoungest')"
              :placeholder="yearInputMask"
              :status="birthyearYoungestStatus"
              @blur="(val: string) => validateBirthyearYoungest(val)"
              @input="(val: string) => validateBirthyearYoungest(val)"
              id="birthyearYoungest"
              inputmode="numeric"
              :value="birthyearYoungest"
            >
              <template v-slot:error>{{ birthyearYoungestError }} </template>
            </BasicTextfield>
          </div>
        </div>
        <div class="card-row search-result" v-if="checkSameVehicleResultText">
          <div class="card-row__col">
            <div class="search-result-text" id="same-vehicle-text">
              <p v-html="checkSameVehicleResultText"></p>
            </div>
          </div>
        </div>
      </div>

      <Modal
        :showModal="showHsnTsnModal"
        :title="$t('change.search.hsnTsnHelpTitle')"
        @closeModal="closeHelpHsnTsn"
        :showCloseIcon="true"
      >
        <template v-slot:content>
          <div class="modal-text">
            {{ $t('change.search.hsnTsnHelpText') }}
          </div>
          <div class="modal-image">
            <img
              class="modal-image"
              :src="`${assetsBaseUrl}/assets/images/hsn_tsn.jpg`"
              alt="hsn_tsn_img"
            />
          </div>
        </template>
      </Modal>

      <Modal
        :showModal="showRegistrationModal"
        :title="$t('change.search.registrationHelpTitle')"
        @closeModal="closeHelpRegistration"
        :showCloseIcon="true"
      >
        <template v-slot:content>
          <div class="modal-text">
            <p v-dompurify-html="$t('change.search.registrationHelpText1')"></p>
            <p v-dompurify-html="$t('change.search.registrationHelpText2')"></p>
          </div>
          <div class="modal-image">
            <img
              class="modal-image"
              :src="`${assetsBaseUrl}/assets/images/registration.jpg`"
              alt="registration_img"
            />
          </div>
        </template>
      </Modal>
    </template>

    <!--Footer with buttons-->
    <template v-slot:footer>
      <!-- Buttons  -->
      <div class="footer-cta footer-cta--right">
        <CustomButton
          @click="checkAllInput"
          :buttonColor="ButtonColor.PRIMARY"
          buttonId="submitButton"
          :buttonType="ButtonType.BUTTON"
          :disabledState="isCTADisabled"
        >
          {{ $t('change.search.calculatePaymentAmount') }}
        </CustomButton>
        <CustomButton
          @click="abort"
          :buttonColor="ButtonColor.LINK"
          buttonId="abortButton"
          :buttonType="ButtonType.BUTTON"
        >
          {{ $t('change.search.abort') }}
        </CustomButton>
      </div>
    </template>
  </Card>
</template>

<script setup lang="ts">
import { computed, onMounted, type PropType, type Ref, ref, watch } from 'vue'
import {
  BasicTextfield,
  ButtonColor,
  ButtonType,
  Card,
  Checkbox,
  CustomButton,
  DateInput,
  InputStatus,
  Modal
} from 'de-zurich-ui-library'
import { policyIdReg } from '@/utilsTenant/PropsValidation'
import {
  type ChangeVehicleSearch,
  type VehicleSearchResult
} from '@/typesTenant/VehicleSelectionApi'
import { formatDate } from '@/utils/policy/PolicyUtils'
import dayjs, { type Dayjs } from 'dayjs'
import { t } from '@/i18n'
import { navigate } from '@/utils/NavigationUtils'
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { formatKilometers } from '@/utils/motor/MotorDataBoxDataUtils'
import { fetchMotorContractByPolicyId } from '@/stores/motorService'
import { searchVehicle } from '@/storeTenant/motorServiceTenant'

dayjs.extend(customParseFormat)

const props = defineProps({
  policyId: {
    type: String,
    required: true,
    validator(value: string): boolean {
      return policyIdReg.test(value)
    }
  },
  changeVehicleSearch: {
    type: Object as PropType<ChangeVehicleSearch>,
    required: false,
    default: null
  }
})

const emit = defineEmits<{
  'get-offer': [value: ChangeVehicleSearch]
  'scroll-to-top': [none: void]
  abort: [none: void]
}>()

const assetsBaseUrl: string = globalThis.ENV_CONFIG?.ASSETS_BASE_URL.CUSTOMER_PORTAL || ''

const dateFormatPattern: string = 'DD.MM.YYYY'
const dateInputMask: string = 'TT.MM.JJJJ'
const yearInputMask: string = 'JJJJ'
const manufacturerRegEx: RegExp = /^\d{4}$/
const typeKeyRegEx: RegExp = /^[0-9A-Za-z]{3}$/
const numberRegEx: RegExp = /^\d+$/
const yearRegEx: RegExp = /^\d{4}$/

const loading = ref(false)
// const InputStatus = InputStatus // make InputStatus available in html template

const manufacturerId: Ref<string> = ref('')
const manufacturerIdValid: Ref<boolean> = ref(false)
const manufacturerIdStatus: Ref<InputStatus> = ref<InputStatus>(InputStatus.DEFAULT)

const typeKey = ref('')
const typeKeyValid = ref(false)
const typeKeyStatus: Ref<InputStatus> = ref<InputStatus>(InputStatus.DEFAULT)

const vehicleSearchResult: Ref<VehicleSearchResult | null> = ref(null)
const vehicleSearchResultText: Ref<string | null> = ref(null)

const firstRegistration = ref('')
const firstRegistrationError = ref('')
const firstRegistrationStatus: Ref<InputStatus> = ref<InputStatus>(InputStatus.DEFAULT)

const firstRegistrationOnMe: Ref<string> = ref('')
const firstRegistrationOnMeError = ref('')
const firstRegistrationOnMeStatus: Ref<InputStatus> = ref<InputStatus>(
  InputStatus.DEFAULT
)
const sameAsFirstRegistrationOnMe = ref(false)

const mileage = ref('')
const mileageError = ref('')
const mileageStatus: Ref<InputStatus> = ref<InputStatus>(InputStatus.DEFAULT)
const milageMaxValue = ref(999000)

const insuranceBegin = ref('')
const insuranceBeginError = ref('')
const insuranceBeginStatus: Ref<InputStatus> = ref<InputStatus>(InputStatus.DEFAULT)

const disabledStatus: Ref<InputStatus> = ref(InputStatus.DISABLED)
const userGroupPartner = ref(false)
const userGroupOthers = ref(false)

const birthyearPartner = ref('')
const birthyearPartnerError = ref('')
const birthyearPartnerStatus: Ref<InputStatus> = ref<InputStatus>(InputStatus.DEFAULT)

const birthyearYoungest = ref('')
const birthyearYoungestError = ref('')
const birthyearYoungestStatus: Ref<InputStatus> = ref<InputStatus>(InputStatus.DEFAULT)

const birthyearOldest = ref('')
const birthyearOldestError = ref('')
const birthyearOldestStatus: Ref<InputStatus> = ref<InputStatus>(InputStatus.DEFAULT)

const minDriverAge: number = 18
const maxDriverAge: number = 99

const showHsnTsnModal = ref(false)
const showRegistrationModal = ref(false)

// should be read from service "coopDate"
const maxCarAgeInYears = ref(30)

const checkSameVehicleResultText: Ref<string | null> = ref(null)

const isCTADisabled = computed(() => {
  return (
    !manufacturerIdValid.value ||
    !typeKeyValid.value ||
    firstRegistrationStatus.value != InputStatus.VALID ||
    (firstRegistrationOnMeStatus.value != InputStatus.VALID &&
      firstRegistrationOnMeStatus.value != InputStatus.DISABLED) ||
    mileageStatus.value != InputStatus.VALID ||
    insuranceBeginStatus.value != InputStatus.VALID
  )
})

onMounted(() => {
  doFillPredefinedInput()
})

watch(
  () => manufacturerIdValid.value && typeKeyValid.value,
  (newValue) => {
    if (newValue) {
      searchVehicleInfo()
    } else {
      // reset search result
      vehicleSearchResult.value = null
      vehicleSearchResultText.value = null
    }
  }
)

function doFillPredefinedInput() {
  if (props.changeVehicleSearch) {
    manufacturerId.value = props.changeVehicleSearch.manufacturerId
    typeKey.value = props.changeVehicleSearch.typeKey
    // date strings are in ISO format, need to be reformatted to german
    firstRegistration.value = formatDate(
      props.changeVehicleSearch.vehicleFirstRegistration
    )
    firstRegistrationOnMe.value = formatDate(
      props.changeVehicleSearch.vehicleFirstRegistrationForPartner
    )
    // the toString is needed here, otherwise the value, which was passed as a number to this component
    // is not rendered correctly in BasicInputfield field
    mileage.value = props.changeVehicleSearch.mileageAtTheBeginning?.toString()
    insuranceBegin.value = formatDate(props.changeVehicleSearch.desiredStartDate)
    birthyearPartner.value = props.changeVehicleSearch.birthyearPartner
    birthyearYoungest.value = props.changeVehicleSearch.birthyearYoungestDriver
    birthyearOldest.value = props.changeVehicleSearch.birthyearOldestDriver
    // as a side effect this inits lookup of vehicle model
    validateAllFields()
  }
}

function str2DayjsDate(val: string | null): Dayjs {
  const valStr: string = val === null ? '' : val
  return dayjs(valStr, dateFormatPattern, true)
}

function validateManufacturerId(updateStatus: boolean, val: string | null): boolean {
  if (val) manufacturerId.value = val
  manufacturerIdValid.value = manufacturerRegEx.test(manufacturerId.value)
  if (updateStatus) {
    manufacturerIdStatus.value = manufacturerIdValid.value
      ? InputStatus.VALID
      : InputStatus.ERROR
  }

  return manufacturerIdValid.value
}

function validateTypeKeyId(updateStatus: boolean, val: string | null): boolean {
  if (val) typeKey.value = val
  typeKeyValid.value = typeKeyRegEx.test(typeKey.value)
  if (updateStatus) {
    typeKeyStatus.value = typeKeyValid.value ? InputStatus.VALID : InputStatus.ERROR
  }

  return typeKeyValid.value
}

function validateFirstRegistration(): boolean {
  const firstReg = str2DayjsDate(firstRegistration.value)
  if (!firstReg.isValid()) {
    firstRegistrationStatus.value = InputStatus.ERROR
    firstRegistrationError.value = t(
      'change.search.validationMessages.dateFormat'
    ) as string
    return false
  }
  // must not be after first registration on me
  if (firstRegistrationOnMeStatus.value === InputStatus.VALID) {
    const firstRegOnMe = str2DayjsDate(firstRegistrationOnMe.value)
    if (firstRegOnMe.isBefore(firstReg)) {
      firstRegistrationStatus.value = InputStatus.ERROR
      firstRegistrationError.value = t(
        'change.search.validationMessages.firstRegistration.afterFirstRegistrationOnMe'
      ) as string
      return false
    }
  }

  if (insuranceBeginStatus.value === InputStatus.VALID) {
    // car must not be older than 30 Years at date of insurance begin
    const minRegDate = str2DayjsDate(insuranceBegin.value).subtract(
      maxCarAgeInYears.value,
      'year'
    )
    if (firstReg.isBefore(minRegDate)) {
      firstRegistrationStatus.value = InputStatus.ERROR
      firstRegistrationError.value = t(
        'change.search.validationMessages.firstRegistration.carTooOld',
        [maxCarAgeInYears.value]
      ) as string
      return false
    }
    // insurance begin date must not be lower than first registration
    const insBeginDate = str2DayjsDate(insuranceBegin.value)
    if (insBeginDate.isBefore(firstReg)) {
      insuranceBeginError.value = t(
        'change.search.validationMessages.insuranceBegin.lowerFirstRegistration'
      ) as string
      insuranceBeginStatus.value = InputStatus.ERROR
      return false
    }
  }
  // insuranceBegin may be invalid, because its date was before firstRegistration
  // so revalidate it
  if (insuranceBeginStatus.value === InputStatus.ERROR) {
    validateInsuranceBegin()
  }
  firstRegistrationStatus.value = InputStatus.VALID
  firstRegistrationError.value = ''

  return true
}

function validateFirstRegistrationOnMe(): boolean {
  // check only if "same as .." checkbox is not selected
  if (!sameAsFirstRegistrationOnMe.value) {
    const firstRegOnMe = str2DayjsDate(firstRegistrationOnMe.value)
    // date is valid
    if (!firstRegOnMe.isValid()) {
      firstRegistrationOnMeStatus.value = InputStatus.ERROR
      firstRegistrationOnMeError.value = t(
        'change.search.validationMessages.dateFormat'
      ) as string
      return false
    }
    // must not be before first registration
    if (firstRegistrationStatus.value === InputStatus.VALID) {
      const firstReg = str2DayjsDate(firstRegistration.value)
      if (firstRegOnMe.isBefore(firstReg)) {
        // error message must be shown in field firstRegistration
        firstRegistrationStatus.value = InputStatus.ERROR
        firstRegistrationError.value = t(
          'change.search.validationMessages.firstRegistration.afterFirstRegistrationOnMe'
        ) as string
        // no error in firstRegistrationOnMe field, so no "return false" here
      }
    }
    firstRegistrationOnMeStatus.value = InputStatus.VALID
    firstRegistrationOnMeError.value = ''
    // insuranceBegin may be invalid, because its date was before firstRegistrationOnMe
    // so revalidate it
    if (insuranceBeginStatus.value === InputStatus.ERROR) {
      validateInsuranceBegin()
    }
  } else {
    firstRegistrationOnMe.value = ''
  }

  return true
}

function validateMileage(updateStatus: boolean, val: string | null): boolean {
  if (val) mileage.value = val
  let mileageValid = true
  if (!mileage.value) {
    mileageError.value = t('change.search.validationMessages.mileage.empty') as string
    mileageValid = false
  } else if (!numberRegEx.test(mileage.value)) {
    mileageError.value = t(
      'change.search.validationMessages.mileage.notANumber'
    ) as string
    mileageValid = false
  } else if (
    isNaN(parseInt(mileage.value, 10)) ||
    parseInt(mileage.value, 10) > milageMaxValue.value
  ) {
    mileageError.value = t('change.search.validationMessages.mileage.invalidRange', {
      maxMileage: formatKilometers(milageMaxValue.value)
    }) as string
    mileageValid = false
  }

  if (updateStatus) {
    mileageStatus.value = mileageValid ? InputStatus.VALID : InputStatus.ERROR
  }

  return mileageValid
}

function validateInsuranceBegin(): boolean {
  const t_insuranceBegin = str2DayjsDate(insuranceBegin.value)
  if (!t_insuranceBegin.isValid()) {
    insuranceBeginError.value = t('change.search.validationMessages.dateFormat') as string
    insuranceBeginStatus.value = InputStatus.ERROR
    return false
  }
  // insurance begin must not be in past
  const today = dayjs().startOf('day')
  const distanceFromToday = t_insuranceBegin.diff(today, 'day')
  if (distanceFromToday < 0) {
    insuranceBeginError.value = t(
      'change.search.validationMessages.insuranceBegin.notInPast'
    ) as string
    insuranceBeginStatus.value = InputStatus.ERROR
    return false
  }
  // insurance begin must not be more than 390 days in the future
  if (distanceFromToday > 390) {
    insuranceBeginError.value = t(
      'change.search.validationMessages.insuranceBegin.over390DaysInFuture',
      [dayjs().add(390, 'day').format(dateFormatPattern)]
    ) as string
    insuranceBeginStatus.value = InputStatus.ERROR
    return false
  }
  // insurance begin date must not be lower than first registration
  if (firstRegistrationStatus.value === InputStatus.VALID) {
    const firstRegDate = str2DayjsDate(firstRegistration.value)
    if (t_insuranceBegin.isBefore(firstRegDate)) {
      insuranceBeginError.value = t(
        'change.search.validationMessages.insuranceBegin.lowerFirstRegistration'
      ) as string
      insuranceBeginStatus.value = InputStatus.ERROR
      return false
    }
  }
  // insurance begin date must not be lower than first registration on me
  if (
    !sameAsFirstRegistrationOnMe.value &&
    firstRegistrationOnMeStatus.value === InputStatus.VALID
  ) {
    const regOnMeDate = str2DayjsDate(firstRegistrationOnMe.value)
    if (t_insuranceBegin.isBefore(regOnMeDate)) {
      insuranceBeginError.value = t(
        'change.search.validationMessages.insuranceBegin.lowerFirstRegistrationOnMe'
      ) as string
      insuranceBeginStatus.value = InputStatus.ERROR
      return false
    }
  }
  insuranceBeginStatus.value = InputStatus.VALID
  insuranceBeginError.value = ''

  // revalidate if car is older than 30 years at insurance begin
  if (firstRegistrationStatus.value === InputStatus.VALID) {
    validateFirstRegistration()
  }

  return true
}

function getYearError(yearStr: string, driverText: string): string {
  if (!yearStr || !yearRegEx.test(yearStr)) {
    return t('change.search.validationMessages.birthyear.wrongFormat') as string
  }
  // check age at insuranceBegin
  if (validateInsuranceBegin()) {
    const birthYear = parseInt(yearStr, 10)
    const insuranceYear = parseInt(str2DayjsDate(insuranceBegin.value).format('YYYY'), 10)
    const age = insuranceYear - birthYear
    if (age < minDriverAge || age > maxDriverAge) {
      return t('change.search.validationMessages.birthyear.invalidRange', [
        driverText,
        minDriverAge,
        maxDriverAge
      ]) as string
    }
  }

  return ''
}

function validateBirthyearPartner(val: string | null): boolean {
  if (val) birthyearPartner.value = val
  if (userGroupPartner.value) {
    birthyearPartnerError.value = getYearError(
      birthyearPartner.value,
      t('change.search.userGroup.thePartner') as string
    )
    if (birthyearPartnerError.value) {
      birthyearPartnerStatus.value = InputStatus.ERROR
      return false
    }
  }

  birthyearPartnerStatus.value = InputStatus.VALID
  return true
}

function validateBirthyearYoungest(val: string | null): boolean {
  if (val) birthyearYoungest.value = val
  if (userGroupOthers.value) {
    birthyearYoungestError.value = getYearError(
      birthyearYoungest.value,
      t('change.search.userGroup.theYoungestDriver') as string
    )
    // Youngest is last field, so compare check is done here
    if (
      !birthyearYoungestError.value &&
      birthyearOldestStatus.value === InputStatus.VALID
    ) {
      if (birthyearYoungest.value < birthyearOldest.value) {
        birthyearYoungestError.value = t(
          'change.search.validationMessages.birthyear.youngestOlderThanOldest'
        ) as string
      }
    }
    if (birthyearYoungestError.value) {
      birthyearYoungestStatus.value = InputStatus.ERROR
      return false
    }
  }

  birthyearYoungestStatus.value = InputStatus.VALID
  return true
}

function validateBirthyearOldest(val: string | null): boolean {
  if (val) birthyearOldest.value = val
  if (userGroupOthers.value) {
    birthyearOldestError.value = getYearError(
      birthyearOldest.value,
      t('change.search.userGroup.theOldestDriver') as string
    )
    if (birthyearOldestError.value) {
      birthyearOldestStatus.value = InputStatus.ERROR
      return false
    }
  }
  birthyearOldestStatus.value = InputStatus.VALID
  return true
}

function validCarFound(): boolean {
  return vehicleSearchResult.value != null
}

function validateAllFields() {
  validateManufacturerId(true, null)
  validateTypeKeyId(true, null)
  validCarFound()
  validateFirstRegistration()
  validateFirstRegistrationOnMe()
  validateMileage(true, null)
  validateInsuranceBegin()
  validateBirthyearPartner(null)
  validateBirthyearOldest(null)
  validateBirthyearYoungest(null)
}

function isAllValid(): boolean {
  let valid = true
  valid = valid && validateManufacturerId(true, null)
  valid = valid && validateTypeKeyId(true, null)
  valid = valid && validCarFound()

  valid = valid && validateFirstRegistration()
  valid = valid && validateFirstRegistrationOnMe()

  valid = valid && validateMileage(true, null)

  valid = valid && validateInsuranceBegin()

  valid = valid && validateBirthyearPartner(null)
  valid = valid && validateBirthyearOldest(null)
  valid = valid && validateBirthyearYoungest(null)

  return valid
}

function sameAsFirstRegClicked(checkedValue: boolean) {
  if (checkedValue) {
    firstRegistrationOnMe.value = ''
    firstRegistrationOnMeError.value = ''
    firstRegistrationOnMeStatus.value = InputStatus.DISABLED
    // revalidate firstRegistration, because there may be error "afterFirstRegistrationOnMe"
    validateFirstRegistration()
  } else {
    firstRegistrationOnMeStatus.value = InputStatus.DEFAULT
  }
}

function userGroupPartnerClicked(checkedValue: boolean) {
  if (!checkedValue) {
    birthyearPartner.value = ''
    birthyearPartnerError.value = ''
    birthyearPartnerStatus.value = InputStatus.DEFAULT
  }
}

function userGroupOthersClicked(checkedValue: boolean) {
  if (!checkedValue) {
    birthyearYoungest.value = ''
    birthyearYoungestError.value = ''
    birthyearYoungestStatus.value = InputStatus.DEFAULT
    birthyearOldest.value = ''
    birthyearOldestError.value = ''
    birthyearOldestStatus.value = InputStatus.DEFAULT
  }
}

function openHelpHsnTsn() {
  showHsnTsnModal.value = true
}

function closeHelpHsnTsn() {
  showHsnTsnModal.value = false
}

function openHelpRegistration() {
  showRegistrationModal.value = true
}

function closeHelpRegistration() {
  showRegistrationModal.value = false
}

function searchVehicleInfo() {
  loading.value = true
  vehicleSearchResult.value = null
  vehicleSearchResultText.value = null

  searchVehicle(manufacturerId.value, typeKey.value)
    .then((result) => {
      vehicleSearchResult.value = result
      vehicleSearchResultText.value = t('change.search.queryResult.found', {
        manufacturer: result.manufacturer,
        modelType: result.modelType,
        kilowatt: result.kilowatt,
        horsepower: result.horsepower
      }) as string
    })
    .catch((error) => {
      if (error.message === 'Unauthorized') {
        navigate(globalThis.ENV_CONFIG?.REDIRECTS.LOGIN_PAGE)
      } else if (error.message === 'NotFound') {
        vehicleSearchResultText.value = t('change.search.queryResult.notFound') as string
      } else if (error.message === 'Conflict') {
        vehicleSearchResultText.value = t('change.search.queryResult.conflict') as string
      } else {
        vehicleSearchResultText.value = t('change.search.queryResult.error') as string
      }
    })
    .finally(() => {
      loading.value = false
    })
}

async function checkAllInput() {
  checkSameVehicleResultText.value = null
  if (isAllValid()) {
    // check if new car equals old car
    loading.value = true

    try {
      const data = await fetchMotorContractByPolicyId(props.policyId)

      const oldVehicle = data?.insuredVehicle
      if (oldVehicle) {
        // convert JSON Date String to german date format
        const oldRegistration = dayjs(oldVehicle.firstRegistration).format(
          dateFormatPattern
        )

        if (
          oldVehicle.manufacturerId === manufacturerId.value &&
          oldVehicle.typeKey?.toUpperCase() === typeKey.value?.toUpperCase() &&
          oldRegistration === firstRegistration.value
        ) {
          // no offer, show info text instead
          checkSameVehicleResultText.value = t(
            'change.search.validationMessages.sameCar'
          ) as string
        } else {
          // go to offer page
          showOffer()
        }
      }
    } catch (error: any) {
      if (error.message === 'Unauthorized') {
        navigate(globalThis.ENV_CONFIG?.REDIRECTS.LOGIN_PAGE)
      } else {
        // no offer, show error message instead
        checkSameVehicleResultText.value = t(
          'change.search.validationMessages.sameCarError'
        ) as string
      }
    } finally {
      loading.value = false
    }
  }
}

function showOffer(): void {
  emit('scroll-to-top')

  const userInput: ChangeVehicleSearch = {
    desiredStartDate: toIsoDate(insuranceBegin.value),
    mileageAtTheBeginning: parseInt(mileage.value, 10),
    vehicleFirstRegistration: toIsoDate(firstRegistration.value),
    vehicleFirstRegistrationForPartner: toIsoDate(
      sameAsFirstRegistrationOnMe.value
        ? firstRegistration.value
        : firstRegistrationOnMe.value
    ),
    sameAsFirstRegistration: sameAsFirstRegistrationOnMe.value,
    typeKey: typeKey.value,
    manufacturerId: manufacturerId.value,
    birthyearPartner: birthyearPartner.value,
    birthyearYoungestDriver: birthyearYoungest.value,
    birthyearOldestDriver: birthyearOldest.value,
    vehicleSearchResult: vehicleSearchResult.value
  }

  emit('get-offer', userInput)
}

function toIsoDate(date: string | null): string {
  if (date) {
    const parsedMoment = dayjs(date, 'DD.MM.YYYY', true)
    return parsedMoment.format('YYYY-MM-DD')
  } else {
    return ''
  }
}

function abort() {
  emit('abort')
}
</script>

<style scoped lang="scss">
.card--md .card-row,
.card--lg .card-row {
  display: flex;
}

/* @media (min-width: 600px) {
  .card-row {
    display: flex;
  }
} */

@media (max-width: 599.99px) {
  .card-row__col.reg-link {
    margin-bottom: 8px;
  }
}

.is-styled .card__content .card-row {
  column-gap: 32px;
}

.container {
  margin-bottom: 32px;
}

.container .inputs {
  padding-top: 16px;
}

// in Ui Lib übernehmen
.checkbox {
  margin-bottom: 2px !important;
}

.h4.title {
  font-family: var(--f-primary-bold);
  margin-bottom: 16px;
}

span.icon-vorteile {
  margin-left: 8px !important;
  font-size: 22px !important;
}

/* Registration support row ordering */
.card .reverse-row-mobile {
  flex-direction: row; /* desktop side by side */
  align-items: flex-start;
}

/* Desktop order: link first, checkbox second */
.reverse-row-mobile .reg-link {
  order: 1;
}

.reverse-row-mobile .reg-checkbox {
  order: 2;
}

.card--xs .reverse-row-mobile {
  display: flex;
  flex-direction: column; /* mobile default: stacked */
  column-gap: 32px;
}

.card--xs .reverse-row-mobile .reg-link {
  order: 99;
}

.separator {
  height: calc(var(--baseline) * 1.5);
}

/*needed to separate the input fields horizontally*/
.form-group {
  padding-right: 12px;
}

.modal-image {
  // seems to be stupid for an image, but works
  text-align: center;
}

.modal-text {
  padding-bottom: calc(var(--baseline) * 0.75);
}

.search-result-text {
  margin-top: 4px;
  border-radius: 4px;
  background: var(--card-header-background-color);
  padding: var(--baseline) calc(var(--grid-gutter-width) * 1.5) var(--baseline)
    calc(var(--grid-gutter-width) * 1.5);

  p {
    margin-bottom: 0;
    color: var(--primary-color-0);

    strong {
      color: var(--primary-color-0);
      font-size: 18px;
    }
  }
}
</style>
